import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RegAgenteControlComunidadAutonomaViewModel } from './agentecontrol.types';
import { UsuarioViewModel, FilterSearchingRegAgenteControlViewModel } from '../../usuarios/usuarios.types';
import { Tc } from '../../../core/_infrastructure/types/common';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { ResetFiltersService } from 'src/app/components/core/_infrastructure/classes/services/reset-filters.service';

@Injectable()
export class AgenteControlService extends ResetFiltersService {
    public currentFilter = new FilterSearchingRegAgenteControlViewModel();

    constructor(
        protected authService: AuthService,
        private http: HttpClient,
        @Inject('BASE_URL') private baseUrl: string,
    ) {
        super(authService);
    }

    getAgenteControl(id: number): Observable<UsuarioViewModel> {
        return this.http.get<UsuarioViewModel>(this.baseUrl + 'api/mantenimiento/regagentecontrol/' + id).pipe();
    }

    getAgenteControlByCa(id: number): Observable<Tc[]> {
        return this.http.get<Tc[]>(this.baseUrl + 'api/mantenimiento/regagentecontrol/agentecontrolByIdCa/' + id).pipe();
    }

    getSiUsuarioExisteComoEA(tecnico: UsuarioViewModel): Observable<boolean> {
        return this.http.post<boolean>(this.baseUrl + 'api/mantenimiento/regagentecontrol/CheckSiUsuarioExisteComoEAAsync', tecnico).pipe();
    }

    addTecnicoExistenteComoACyEA(tecnico: UsuarioViewModel): Observable<any> {
        return this.http.post<UsuarioViewModel>(this.baseUrl + 'api/mantenimiento/regagentecontrol/PostUsuarioExistenteComoACyEAAsync', tecnico).pipe();
    }

    createAgenteControl(entidad: UsuarioViewModel): Observable<any> {
        return this.http.post<UsuarioViewModel>(this.baseUrl + 'api/mantenimiento/regagentecontrol', entidad).pipe();
    }

    editAgenteControl(entidad: UsuarioViewModel): Observable<any> {
        return this.http.put<UsuarioViewModel>(this.baseUrl + 'api/mantenimiento/regagentecontrol', entidad).pipe();
    }

    deleteAgenteControl(id: number): Observable<any> {
        return this.http.delete<UsuarioViewModel>(this.baseUrl + 'api/mantenimiento/regagentecontrol/' + id).pipe();
    }

    deleteTecnicoExistenteComoACyEA(tecnico: UsuarioViewModel): Observable<any> {
        return this.http.put<UsuarioViewModel>(this.baseUrl + 'api/mantenimiento/regagentecontrol/DeleteTecnicoExistenteComoACyEAAsync', tecnico).pipe();
    }

    reactivateTecnicoExistenteComoACyEA(tecnico: UsuarioViewModel): Observable<any> {
        return this.http.put<UsuarioViewModel>(this.baseUrl + 'api/mantenimiento/regagentecontrol/ReactivateTecnicoExistenteComoACyEAAsync', tecnico).pipe();
    }

    export(model: FilterSearchingRegAgenteControlViewModel): Observable<HttpResponse<Blob>> {
        return this.http
            .post(this.baseUrl + 'api/mantenimiento/regagentecontrol/postExportExcelByFilter', model, { observe: 'response', responseType: 'blob' })
            .pipe();
    }

    postGetPagedByFilter(model: FilterSearchingRegAgenteControlViewModel): Observable<any> {
        return this.http.post(this.baseUrl + 'api/mantenimiento/regagentecontrol/postGetPagedByFilter', model).pipe();
    }

    //Agente de Control Comunidad Autónoma

    getAgenteControlComunidadAutonoma(id: number): Observable<RegAgenteControlComunidadAutonomaViewModel> {
        return this.http.get<RegAgenteControlComunidadAutonomaViewModel>(this.baseUrl + 'api/mantenimiento/regagentecontrol/agentecontrolca/' + id).pipe();
    }

    addAgenteControlComunidadAutonoma(caAgente: RegAgenteControlComunidadAutonomaViewModel): Observable<any> {
        return this.http
            .post<RegAgenteControlComunidadAutonomaViewModel>(this.baseUrl + 'api/mantenimiento/regagentecontrol/postagentecontrolca', caAgente)
            .pipe();
    }

    editAgenteControlComunidadAutonoma(caAgente: RegAgenteControlComunidadAutonomaViewModel): Observable<any> {
        return this.http
            .put<RegAgenteControlComunidadAutonomaViewModel>(this.baseUrl + 'api/mantenimiento/regagentecontrol/putagentecontrolca', caAgente)
            .pipe();
    }

    deleteAgenteControlComunidadAutonoma(id: number): Observable<any> {
        return this.http
            .delete<RegAgenteControlComunidadAutonomaViewModel>(this.baseUrl + 'api/mantenimiento/regagentecontrol/deleteagentecontrolca/' + id)
            .pipe();
    }

    resetFilter() {
        this.currentFilter = new FilterSearchingRegAgenteControlViewModel();
    }
}
